const userPermissions = {
  LOGIN: 1,
  VIEW_USERS: 2,
  CREATE_USERS: 4,
  EDIT_USERS: 8,
  DELETE_USERS: 16,
  VIEW_TRANSACTIONS: 32,
  CREATE_TRANSACTIONS: 64,
  EDIT_TRANSACTIONS: 128,
  DELETE_TRANSACTIONS: 256,
  VIEW_TAG_CATEGORIES: 512,
  SUPER_ADMIN: 1024,
  CREATE_TAG_CATEGORIES: 2048,
  EDIT_TAG_CATEGORIES: 4096,
}

export default userPermissions
